import { Record as record } from 'immutable';

import {FareFilterSelections} from '../constants/AppConstants';

const defaults = {
    showStandard: true,
    showFirstClass: false,
    selection: FareFilterSelections.CHEAPEST,
};


class DisplayFilters extends record(defaults) {
    static fromJSON (json = {}) {
        return new DisplayFilters({
            showStandard: json.showStandard,
            showFirstClass: json.showFirstClass,
            selection: json.selection || FareFilterSelections.CHEAPEST
        });
    }
}

export default DisplayFilters;
